// JsFromRoutes CacheKey e0ff1d39e06cf73732d85dfc2ceecd43
//
// DO NOT MODIFY: This file was automatically generated by JsFromRoutes.
import { definePathHelper } from '@js-from-routes/axios'

export default {
  destroy: definePathHelper('delete', '/notification/:id')
}
